/**
 * Fix links and prepends https:// if not done already
 */
export default function fixLink(link) {
  const prefix = "https://";

  return link.substr(0, prefix.length) !== prefix ? prefix + link : link;
}
